<template>
  <div id="dashboard" class="dashboard col-md-2">
    <div id="user" class="user">
      <img
        src="https://cdn.dribbble.com/users/19658/screenshots/3576141/media/ca38af59f2434493f8cb9c4229cbfc2e.png?compress=1&resize=400x300"
        alt=""
        width="50px"
        style="border-radius: 50%"
      />
      <h4 id="username">{{userData.email}}</h4>
      <h5 id="userrole">{{userData.role}}</h5>
      <hr />
    </div>
    <div id="dashboard-list">
      <ul class="dashboard-list">
        <li>
          <p><a href="" @click.prevent="foodListButton">Food List</a></p>
        </li>
        <li>
          <p><a href="" @click.prevent="HistoryLog">History Log</a></p>
        </li>
        <li>
          <p><a href="" @click.prevent="createFoodButton">Create Food</a></p>
        </li>
        <li>
          <p><a href="" @click="logout">Logout</a></p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "../apis/server";
export default {
  name: "Dashboard",
  data(){
    return{
      userData: ''
    }
  },
  methods: {
    logout() {
      localStorage.clear();
    },
    foodListButton() {
      this.$emit("getFoodList");
    },
    createFoodButton() {
      this.$emit("getAddFoodForm");
    },
    HistoryLog() {
      this.$emit("HistoryLog");
    },
  },
  created() {
    axios({
      url: "/userdata",
      method: "get",
      headers: {access_token: localStorage.getItem('access_token')}
    })
    .then(({data})=>{
      this.userData = data
    })
  },
};
</script>

<style>
</style>